<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} Đơn vị cung cấp</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="9">
              <b-col md="12">
                <el-form-item
                  :label="'TRẠNG THÁI HIỆN TẠI CỦA CƠ SỞ' + (mData.dataForm.diem_den_an_toan.hoat_dong && mData.dataForm.diem_den_an_toan.hoat_dong.thoi_diem_thay_doi_cuoi ? ' (Lần thay đổi gần nhất: ' + new Intl.DateTimeFormat('vi-VN', options).format(new Date(mData.dataForm.diem_den_an_toan.hoat_dong.thoi_diem_thay_doi_cuoi)) + ')' : '')"
                  prop="ngung_hoat_dong">
                  <div class="form-css">
                    <el-radio :disabled="mData.viewMode == 'accept'" class="checkbox-active"
                      v-model='mData.dataForm.diem_den_an_toan.hoat_dong.ngung_hoat_dong'
                      @change="fn_chuyenTrangThaiHoatDong(false)" :label="false">HOẠT ĐỘNG</el-radio>
                    <el-radio :disabled="mData.viewMode == 'accept'" class="checkbox-inactive"
                      v-model='mData.dataForm.diem_den_an_toan.hoat_dong.ngung_hoat_dong'
                      @change="fn_chuyenTrangThaiHoatDong(true)" :label="true">NGỪNG HOẠT ĐỘNG</el-radio>
                  </div>
                </el-form-item>
              </b-col>
              <b-row>
                <b-col md="6">
                  <el-form-item label="Đơn vị cung cấp" prop="don_vi_cung_cap.du_lieu_khai_bao.user_ten">
                    <el-input type="text" v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_ten"
                      :disabled="mData.viewMode == 'accept'" clearable></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="12">
                  <el-form-item>
                    <span slot="label">
                      <p class="mb-0">Ưu đãi khi thanh toán bằng <span class="bold card__du-lich"
                          @click="gotoNewPage">Thẻ du lịch</span> trên tổng hóa đơn* </p>
                    </span>
                    <ElementUiMoney v-model="mData.dataForm.diem_den_an_toan.thong_tin_chung.gia_tri_uu_dai" label=""
                      :disabled="true" :outlined="true" :clearable="true" />
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="3">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="user_anh">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'accept'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Địa chỉ
                  <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapseDiaChi v-b-tooltip.hover
                      :title="aLang.c_toggle">
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiaChi" visible>
                  <b-row>
                    <b-col md="6">
                      <b-row>
                        <b-col md="6">
                          <el-form-item label="Tỉnh/Thành phố" prop="don_vi_cung_cap.du_lieu_khai_bao.dia_chi_tinh_id">
                            <el-select v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.dia_chi_tinh_id"
                              :placeholder="aLang.c_select" :disabled="mData.viewMode == 'accept'" clearable filterable>
                              <el-option v-for="item in mData.dataDefault.listProvince" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item label="Quận/huyện" prop="don_vi_cung_cap.du_lieu_khai_bao.dia_chi_huyen_id">
                            <el-select v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.dia_chi_huyen_id"
                              :placeholder="aLang.c_select" :disabled="mData.viewMode == 'accept'" clearable filterable>
                              <el-option v-for="item in mData.dataDefault.listDistrict" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="6">
                          <el-form-item label="Xã/Phường" prop="don_vi_cung_cap.du_lieu_khai_bao.dia_chi_xa_id">
                            <el-select v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.dia_chi_xa_id"
                              :placeholder="aLang.c_select" :disabled="mData.viewMode == 'accept'" clearable filterable>
                              <el-option v-for="item in mData.dataDefault.listCommune" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item label="Địa chỉ" prop="don_vi_cung_cap.du_lieu_khai_bao.user_dia_chi">
                            <el-input type="text" v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_dia_chi"
                              :disabled="mData.viewMode == 'accept'" clearable></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col>
                          <el-form-item label="Địa chỉ trên bản đồ">
                            <mapbox-component :viewMode="mData.viewMode" @update="fn_getDataFromMapboxComponent"
                              :cordinatesValue="mData.mapDataObject.value" v-if="mData.dataDefault.showMap"
                              id="mapBox"></mapbox-component>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Người đại diện
                  <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapseNguoiDaiDien v-b-tooltip.hover
                      :title="aLang.c_toggle">
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseNguoiDaiDien" visible>
                  <b-row>
                    <b-col md="3">
                      <el-form-item label="Tên người đại diện" prop="don_vi_cung_cap.du_lieu_khai_bao.ho_ten">
                        <el-input type="text" v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.ho_ten"
                          :disabled="mData.viewMode == 'accept'" clearable></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Chức vụ" prop="don_vi_cung_cap.du_lieu_khai_bao.chuc_vu">
                        <el-input type="text" v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.chuc_vu"
                          :disabled="mData.viewMode == 'accept'" clearable></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Điện thoại" prop="don_vi_cung_cap.du_lieu_khai_bao.user_dien_thoai">
                        <el-input type="text" v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_dien_thoai"
                          :disabled="mData.viewMode == 'accept'" clearable></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Số CMTND/CCCD/Hộ chiếu"
                        prop="don_vi_cung_cap.du_lieu_khai_bao.user_so_giay_to">
                        <el-input type="text" v-model="mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.user_so_giay_to"
                          :disabled="mData.viewMode == 'accept'" clearable></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  ALBUM
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseAlbum
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseAlbum" visible>
                  <b-row class="mb-1">
                    <b-col md="3">
                      <el-form-item label="Ngôn ngữ" prop="ngon_ngu">
                        <el-select
                          v-model="mData.dataForm.diem_den_an_toan.ngon_ngu"
                          @change="fn_changeLanguage(mData.dataForm.diem_den_an_toan.ngon_ngu)"
                          :placeholder="aLang.c_select"
                          @input="forceUpdateUI"
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listNgonNgu"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col md="12" class="d-flex-album">
                      <label class="label-image" style="margin-right: 10px;">ALBUM ẢNH</label>
                      <el-popover
                        style="color: #fff;"
                        placement="bottom-start"
                        width="300"
                        trigger="click"
                      >
                        <el-link href="javascript:" class="warning-text" slot="reference"><i class="el-icon-info" style="margin-right: 5px;"></i>Lưu ý khi tải ảnh</el-link>
                        <div class="alert-message">
                          <p>
                            Hình ảnh sau khi đăng tải sẽ được thay đổi kích thước để hiển thị phù hợp trên giao diện ứng dụng Du lịch Việt Nam an toàn.
                            Để chất lượng hình ảnh tối ưu nhất, kích thước ảnh gốc khuyến khích sử dụng theo tỷ lệ 2:3!
                          </p>
                        </div>
                      </el-popover>
                    </b-col>
                    <b-col
                      v-for="(item,index) in mData.dataForm.diem_den_an_toan.listImageUrl"
                      :key="index"
                      md="4"
                      xl="3"
                      :class="{
                        'text-center mt-2': true,
                        'hide-element-blank': !item.anh_id
                      }"
                      v-if="showList"
                    >
                      <div class="position-css">
                        <el-image
                          fit="cover"
                          class="el-image-css"
                          :src="item.url"
                          :preview-src-list="mData.dataDefault.listAlbumImage"
                          :lazy="true"
                          v-if="!fn_checkVideo(item)"
                        >
                          <!-- <img :src="item.url.replace('&r=clip&w=400&h=600&ha=center','')" alt="" style="z-index:9999;"> -->
                          <div slot="error" class="el-image__error">
                            <span class="small" style="line-height: 1rem">{{
                              item.name ? item.name : ''
                            }}</span>
                          </div>
                        </el-image>
                        <div style="position: relative; cursor: pointer;" v-if="fn_checkVideo(item)" @click="fn_playVideo(item)">
                          <video
                            class="video-css"
                          >
                            <source
                              :src="item.url"
                              :type="fn_changeType(item.type)"
                            />
                          </video>
                          <div class="play-icon-custom">
                            <i class="fa fa-play play-icon-css" aria-hidden="true"></i>
                          </div>
                        </div>
                        <el-form-item class="text-left mb-4 margin-auto" label="Chú thích">
                          <el-input
                            class="mt-2"
                            type="textarea"
                            :rows="3"
                            maxlength="150"
                            show-word-limit
                            v-model="
                              item.tieu_de
                            "
                            clearable
                            disabled
                            @input="forceUpdateUI"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <label class="label-infomation">THÔNG TIN CHI TIẾT</label>
                    </b-col>
                    <b-col md="12">
                      <el-form-item :label="'Nội dung'" prop="noi_dung">
                        <editor-component
                          :prop-data-editor="mData.dataForm.diem_den_an_toan.noiDungHienThiFilter"
                          :prop-data-editor-key="'noi_dung'"
                          :prop-data-editor-disabled="true"
                        ></editor-component>
                      </el-form-item>
                    </b-col>
                    <!-- <b-col md="12">
                      <el-form-item label="Giới thiệu">
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="
                          mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.gioi_thieu
                          "
                          clearable
                          disabled
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item class="mb-3" label="Ảnh">
                        <el-upload
                          disabled
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhThongTin.limit"
                          :accept="mData.fileUploadOption.AnhThongTin.accept"
                          :on-preview="fn_uploadPreviewAnhThongTin"
                          :file-list="mData.fileUploadOption.AnhThongTin.fileList"
                          :class="[mData.fileUploadOption.AnhThongTin.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhThongTin.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhThongTin.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Nội dung">
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="
                            mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.noi_dung
                          "
                          clearable
                            disabled
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col> -->
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Ưu đãi cho hướng dẫn viên
                  <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapseUuDaiHDV v-b-tooltip.hover
                      :title="aLang.c_toggle">
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseUuDaiHDV" visible>
                  <b-row>
                    <b-col md="12">
                      <el-checkbox v-model="checked" disabled>Chiết khấu cho Hướng dẫn viên</el-checkbox>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Loại hình ưu đãi" prop="">
                        <el-select
                          v-model="mData.dataForm.diem_den_an_toan.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai"
                          placeholder="Chọn loại hình ưu đãi" disabled clearable @input="forceUpdateUI">
                          <el-option v-for="item in mData.dataDefault.listLoaiHinhUuDai" :key="item.value"
                            :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4"
                      v-if="mData.dataForm.diem_den_an_toan.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai == 'giam_gia_tien'">
                      <el-form-item label="Giá trị ưu đãi (VND)" prop="">
                        <ElementUiMoney :disabled="true"
                          v-model="mData.dataForm.diem_den_an_toan.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai"
                          label="" :placeholder="'Nhập giá trị ưu đãi'" :outlined="true" :clearable="true"
                          @input="forceUpdateUI" @change="forceUpdateUI" />
                      </el-form-item>
                    </b-col>
                    <b-col md="4"
                      v-if="mData.dataForm.diem_den_an_toan.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai == 'giam_gia_phan_tram'">
                      <el-form-item label="Giá trị ưu đãi (%)" prop="">
                        <el-input-number disabled
                          v-model="mData.dataForm.diem_den_an_toan.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai"
                          :min="1" :max="100" :controls="false" placeholder="Nhập giá trị ưu đãi"
                          @input="forceUpdateUI"></el-input-number>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button type="danger" plain @click="fn_submitForm('not-accpet')" v-ladda>Từ chối</el-button>
            <el-button type="success" plain @click="fn_submitForm('accpet')" v-ladda>Duyệt</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="position: fixed; width: 100%; height: 100%; background: rgba(80, 67, 67, 0.79); top: 0; left: 0; z-index: 99999;" v-if="mData.dataDefault.dialogVideo.show">
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); max-width: 80%, max-height: 80%;">
        <video autoplay controls class="video-control">
          <source :src="mData.dataDefault.dialogVideo.src" :type="mData.dataDefault.dialogVideo.type">
        </video>
      </div>
      <div style="position: absolute; right: 20px; top: 45px; cursor: pointer;" @click="fn_closeDialogVideo()">
        <i class="fa fa-times" style="font-size: 36px; color: #ffffff;" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import ApiService from '@/service/ApiService';
import config from "../../../config.json";
import DDATModel from '@/views/admin/DDAT/DDATModel';
import ShareDDATModel from '@/views/admin/ShareModel/ShareDDATModel';
import ShareDichVuModel from '@/views/admin/ShareModel/ShareDichVuModel';
import ShareDonViCungCapModel from '@/views/admin/ShareModel/ShareDonViCungCapModel';
import DDATApi from '@/moduleApi/DDATApi';
import DonViCungCapChoDuyetApi from '@/moduleApi/DonViCungCapChoDuyetApi';
import MapComponent from "../../../component/MapComponent";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CommuneApi from "../../../moduleApi/CommuneApi";
import MapboxComponent from "../../../component/MapboxComponent";
import ElementUiMoney from '@/component/ElementUiMoney';
import EditorComponent from "@/component/EditorComponent";

export default {
  components: {
    MapComponent,
    MapboxComponent,
    ElementUiMoney,
    EditorComponent
  },
  data() {
    return {
      checked: false,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "accept",
        moduleName: "DichVuVanTaiKhach",
        urlImg: ExtensionService.urlSurveyImg,
        dataDefault: {
          roles: DataService.rolesInForm,
          listGioiTinh: DataService.gioiTinh,
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          listLoaiHinh: MethodService.copyObject(DataService.loaiHinhRegister),
          listTieuChiAnToan: [],
          listImageUrl: [],
          showMap: false,
          listNgonNgu: DataService.Languages,
          listAlbumImage: [],
          dialogVideo: {
            show: false,
            src: "",
            type: ""
          }
        },
        // dataForm: MethodService.copyObject(DDATModel.dataForm),
        dataForm: {
          diem_den_an_toan: MethodService.copyObject(ShareDDATModel.dataForm),
          don_vi_cung_cap: MethodService.copyObject(ShareDonViCungCapModel.dataForm),
          dich_vu: MethodService.copyObject(ShareDichVuModel.dataForm)
        },
        dataFormOther: MethodService.copyObject(
          DDATModel.dataFormOther
        ),
        validForm: DDATModel.validForm,
        validFormOther: DDATModel.validFormOther,
        ifHavePermission: true,

        fileUploadOption: {
          //MethodService.copyObject(DDATModel.dataFormOther.fileUploadOption),
          AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          },
          AnhGiayTo: {
            limit: null,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          },
          AlbumAnh: {
            limit: null,
            accept: ".jpg, .png, .jpeg, .mp4, .avi, .mov",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
          AnhThongTin: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          }
        },
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem"
        },
        mapDataObject: {
          value: [107.9, 14.01667],
          geoJson: {
            type: "",
            coordinates: []
          }
        },
        albumAnhFilter: [{
          anh_id: undefined,
          tieu_de: undefined,
        }],
        notAllowToChange: false,
        isActive: true,
        disableUpload: false
      },
      typeVideo: ["mp4", "avi", "mov"],
      typeImage: ["jpg", 'png', "jpeg"],
      typeAccept: ["mp4", "avi", "mov", "jpg", 'png', "jpeg"],
      showList: true
    };
  },
  methods: {
    gotoNewPage() {
      window.open("http://thedulich.gov.vn/", '_blank').focus();
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm.don_vi_cung_cap);
          if (type == "accpet") {
            data.du_lieu_khai_bao.toa_do = this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do.toString();
            data.duyet = {
              duoc_duyet: true
            }
            await DonViCungCapChoDuyetApi.approvedDonVi(data);
            this.fn_go();
            this.$store.commit("fn_countDichVuVanTaiKhach");
          } else if (type == "not-accpet") {
            data.du_lieu_khai_bao.toa_do = this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do.toString();
            data.duyet = {
              duoc_duyet: false
            }
            await DonViCungCapChoDuyetApi.approvedDonVi(data);
            this.fn_go();
            this.$store.commit("fn_countDichVuVanTaiKhach");
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.mData.fileUploadOption = MethodService.copyObject(
        DDATModel.dataFormOther.fileUploadOption
      );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      DDATApi.clearCache();
      let res = await DonViCungCapChoDuyetApi.findById(id);
      if (res.result) {
        this.mData.dataForm.don_vi_cung_cap = res.result;
        this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do = this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do.split(",");
        if (res.result.du_lieu_khai_bao && res.result.du_lieu_khai_bao.user_anh) {
          let data = {
            id: res.result.du_lieu_khai_bao.user_anh,
            name: res.result.du_lieu_khai_bao.user_anh,
            url: ExtensionService.urlSurveyImg + res.result.du_lieu_khai_bao.user_anh
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
        if (
          this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do
        ) {
          this.mData.dataPropMapDiaDiem.lat =
            this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do[1];
          this.mData.dataPropMapDiaDiem.lng =
            this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do[0];
          this.mData.dataPropMapDiaDiem.showMap = true;

          let coordinate = [
            this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do[0],
            this.mData.dataForm.don_vi_cung_cap.du_lieu_khai_bao.toa_do[1]
          ];
          this.mData.mapDataObject.value = coordinate;
          this.mData.mapDataObject.geoJson.type = "Point";
          this.mData.mapDataObject.geoJson.coordinates = coordinate;
          this.mData.dataDefault.showMap = true;
        }

        if (
          res.result.du_lieu_khai_bao &&
          res.result.du_lieu_khai_bao.dia_chi_tinh_id
        ) {
          let resProvince = await ProvinceApi.findById(
            res.result.du_lieu_khai_bao.dia_chi_tinh_id
          );

          this.mData.dataDefault.listProvince.push(resProvince.result);
        }
        if (
          res.result.du_lieu_khai_bao &&
          res.result.du_lieu_khai_bao.dia_chi_huyen_id
        ) {
          let resDistrict = await DistrictApi.findById(
            res.result.du_lieu_khai_bao.dia_chi_huyen_id
          );
          this.mData.dataDefault.listDistrict.push(resDistrict.result);
        }

        if (
          res.result.du_lieu_khai_bao &&
          res.result.du_lieu_khai_bao.dia_chi_xa_id
        ) {
          let resCommune = await CommuneApi.findById(
            res.result.du_lieu_khai_bao.dia_chi_xa_id
          );
          this.mData.dataDefault.listCommune.push(resCommune.result);
        }
      }
      let hoatDong = {};
      let ddatRes = await DDATApi.findById(id);
      if (ddatRes.result) {
        if (!ddatRes.result.noi_dung_hien_thi) ddatRes.result.noi_dung_hien_thi = []
        if (!ddatRes.result.album) ddatRes.result.album = []
        this.mData.dataForm.diem_den_an_toan = ddatRes.result;
        if (ddatRes.result.hoat_dong == undefined) {
          hoatDong = { ngung_hoat_dong: false };
        } else {
          hoatDong = ddatRes.result.hoat_dong;
        }
        this.mData.dataForm.diem_den_an_toan.hoat_dong = hoatDong;
        this.mData.dataForm.diem_den_an_toan.ngon_ngu = 'vi'
        this.fn_changeLanguage(this.mData.dataForm.diem_den_an_toan.ngon_ngu)
        if (
          !ddatRes.result.thong_tin_chung.huong_dan_vien
        ) {
          this.mData.dataForm.diem_den_an_toan.thong_tin_chung.huong_dan_vien = {
            uu_dai: {
              loai_hinh_uu_dai: undefined,
              gia_tri_uu_dai: undefined
            }
          }
        } else {
          this.checked = true;
        }
      }
    },
    fn_chuyenTrangThaiHoatDong(trangThai) {
      let message = "";
      if (trangThai) {
        message = 'Bạn có chắc muốn chuyển trạng thái thành CƠ SỞ TẠM NGỪNG HOẠT ĐỘNG hay không?';
      } else {
        message = 'Bạn có chắc muốn chuyển trạng thái thành HOẠT ĐỘNG hay không?';
      }
      this.$confirm(message, {
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning",
      })
        .then(async () => {
          let data = {
            id: this.mData.dataForm.diem_den_an_toan.id,
            hoat_dong: {
              ngung_hoat_dong: trangThai
            }
          };
          try {
            await ApiService.patch(config.hostApiDuLich + 'diem_den_an_toans/' + this.mData.dataForm.diem_den_an_toan.id,
              data).then(() => {
                this.fn_affterChangeStatus(this.$router.currentRoute.params.id);
              });
          } catch (error) {
            console.info('ERROR : ', error.toString());
          }
          this.$forceUpdate();
        })
        .catch(() => {
          this.mData.dataForm.diem_den_an_toan.hoat_dong.ngung_hoat_dong = !trangThai;
        });
    },
    async fn_affterChangeStatus(id) {
      DDATApi.clearCache();
      let ddatRes = await DDATApi.findById(id);
      if (ddatRes.result) {
        this.mData.dataForm.diem_den_an_toan = ddatRes.result;
        if (ddatRes.result.hoat_dong == null) {
          this.mData.dataForm.diem_den_an_toan.hoat_dong = {};
        } else {
          this.mData.dataForm.diem_den_an_toan.hoat_dong.ngung_hoat_dong = ddatRes.result.hoat_dong.ngung_hoat_dong;
        }
        if (!ddatRes.result.hoat_dong || !ddatRes.result.hoat_dong.thoi_diem_thay_doi_cuoi) {
          this.mData.dataForm.diem_den_an_toan.hoat_dong.thoi_diem_thay_doi_cuoi = "";
        } else {
          this.mData.dataForm.diem_den_an_toan.hoat_dong.thoi_diem_thay_doi_cuoi = ddatRes.result.hoat_dong.thoi_diem_thay_doi_cuoi;
        }
      }
    },
    async fn_initDataDefault() { },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.don_vi_cung_cap.don_vi_cung_cap.du_lieu_khai_bao.user_anh = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("don_vi_cung_cap.don_vi_cung_cap.du_lieu_khai_bao.user_anh");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "anhDaiDien")
        .then(res => {
          this.mData.dataForm.don_vi_cung_cap.don_vi_cung_cap.du_lieu_khai_bao.user_anh = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("don_vi_cung_cap.don_vi_cung_cap.du_lieu_khai_bao.user_anh");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("don_vi_cung_cap.don_vi_cung_cap.du_lieu_khai_bao.user_anh");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_addLatLngDiaDiem(lat, lng) {
      this.mData.dataForm.thong_tin_chung.dia_chi.vi_do = lat;
      this.mData.dataForm.thong_tin_chung.dia_chi.kinh_do = lng;
    },

    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },
    fn_download(file) {
      window.open(ExtensionService.urlSurveyFile + file.id);
    },

    // Album ảnh
    fn_uploadCheckFileImageSize(file) {
      return MethodService.checkFileSize(file, 10);
    },
    //up load videolistImageUrl
    fn_uploadCheckFileVideoSize(file) {
      return MethodService.checkFileSize(file, 50);
    },

    fn_filterImageUrl(arrImage){
      let imageExtension = ["jpg","jpeg","png","gif","bmp","tiff","webp","svg"];
      let imageUrls = arrImage.filter(x => typeof(x.type) == "string" && imageExtension.includes(x.type.toLowerCase())).map((a) => a.url);
      this.mData.dataDefault.listAlbumImage = imageUrls;
      for (let i = 0; i < this.mData.dataDefault.listAlbumImage.length; i++) {
        this.mData.dataDefault.listAlbumImage[i] = this.mData.dataDefault.listAlbumImage[i].replace("&r=clip&w=400&h=600&ha=center","");
      }
    },

    fn_checkTypeFile(fileType){
      return MethodService.checkFileType(fileType);
    },

    fn_checkCountFile(fileList, typeFile){
      if(this.typeVideo.includes(typeFile)){
        if(fileList.filter(e => this.typeVideo.includes(e.type)).length == 3){
          window.toastr.info("Chỉ tải lên tối đa 3 video");
          return false;
        }else{
          return true;
        }
      }else{
        if(fileList.filter(e => !this.typeVideo.includes(e.type)).length == 10){
          window.toastr.info("Chỉ tải lên tối đa 10 ảnh");
          return false;
        }else{
          return true;
        }
      }
    },
    fn_disableUploadFile(fileList){
      this.mData.disableUpload = (fileList.length === 13)
    },
    fn_uploadChangeAlbumAnh(file, fileList) {
      let fileType = file.name.substr(file.name.length - 4, 4).replace(".","").toLowerCase();
      if (!this.typeAccept.includes(fileType)) {
        window.toastr.warning("Định dạng file hỗ trợ mp4, avi, mov, jpg, png, jpeg! Vui lòng tải các file đúng định dạng!");
        return
      }
      let item = {};
      let listImage = [];
      if (this.fn_checkTypeFile(fileType) && this.fn_uploadCheckFileImageSize(file)) {
        if (this.fn_uploadCheckFileVideoSize(file)) {
          this.mData.albumAnhFilter = this.mData.dataForm.diem_den_an_toan.listImageUrl;
          if (!this.fn_checkCountFile(this.mData.albumAnhFilter, fileType)) {
            return
          }
          ExtensionService.upload(file, "anhAlbum")
          .then((res) => {
            this.showList = false
            this.mData.albumAnhFilter.push({anh_id:res.result, tieu_de: undefined, type: fileType, ngon_ngu: this.mData.dataForm.diem_den_an_toan.ngon_ngu});
            for (const element of this.mData.albumAnhFilter) {
              element.url = ExtensionService.urlImg + element.anh_id + "&r=clip&w=400&h=600&ha=center";
              item = {
                name: element.anh_id,
                anh_id: element.anh_id,
                ngon_ngu: this.mData.dataForm.diem_den_an_toan.ngon_ngu,
                tieu_de: element.tieu_de,
                type: element.type
              };
              item.url =
                ExtensionService.urlImg +
                element.anh_id +  (this.typeImage.includes(item.type) ? "&r=clip&w=400&h=600&ha=center" : "");
              listImage.push(item);
            }
            this.saveTemporaryAlbum();
            this.fn_filterImageUrl(this.mData.albumAnhFilter);
            this.fn_disableUploadFile(listImage)
            this.mData.dataForm.diem_den_an_toan.listImageUrl = listImage;
            this.showList = true
          })
          .catch(() => {this.showList = true});
        }
      }else{
        if(this.typeVideo.includes(fileType)){
          window.toastr.warning("Chỉ tải lên video không quá 50MB");
        }else{
          window.toastr.warning("Chỉ tải lên ảnh không quá 10MB");
        }

      }
    },
    saveTemporaryAlbum(){
      let arrIndex = [];
      this.mData.dataForm.diem_den_an_toan.album.filter((e , index) => {
        if(e.ngon_ngu == this.mData.dataForm.diem_den_an_toan.ngon_ngu){
          arrIndex.push(index);
          return e;
        }
      });
      for(let i = arrIndex.length-1; i >= 0; i--){
        this.mData.dataForm.diem_den_an_toan.album.splice(arrIndex[i],1);
      }
      for(const element of this.mData.dataForm.diem_den_an_toan.listImageUrl){
        this.mData.dataForm.diem_den_an_toan.album.push(element);
      }
    },
    saveTemporaryInformationDetail(){
      let thongTin = this.mData.dataForm.diem_den_an_toan.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataForm.diem_den_an_toan.ngon_ngu && e.anh_id);
      if(!thongTin){
        this.mData.dataForm.diem_den_an_toan.noi_dung_hien_thi.push(this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter)
      }else {
        this.mData.dataForm.diem_den_an_toan.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataForm.diem_den_an_toan.ngon_ngu).gioi_thieu = this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.gioi_thieu;
        this.mData.dataForm.diem_den_an_toan.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataForm.diem_den_an_toan.ngon_ngu).anh_id = this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.anh_id;
        this.mData.dataForm.diem_den_an_toan.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataForm.diem_den_an_toan.ngon_ngu).noi_dung = this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.noi_dung;
      }
    },
    fn_uploadRemoveAnhThongTin(file, fileList) {
      this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.anh_id = null;
      this.mData.fileUploadOption.AnhThongTin.fileList = [];
      this.saveTemporaryInformationDetail();
    },
    fn_uploadChangeAnhThongTin(file, fileList) {
      ExtensionService.upload(file, "anhHienThi")
        .then(res => {
          this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.anh_id = res.result;
          this.mData.fileUploadOption.AnhThongTin.fileList = fileList;
          this.saveTemporaryInformationDetail();
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhThongTin(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhThongTin.limit} file`
      );
    },
    fn_uploadPreviewAnhThongTin(file) {
      this.mData.fileUploadOption.AnhThongTin.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhThongTin.dialogVisible = true;
    },
    fn_changeLanguage(lang){
      console.log('lang', lang);
      this.mData.fileUploadOption.AnhThongTin.fileList = []
      this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter = this.mData.dataForm.diem_den_an_toan.noi_dung_hien_thi.find(e => e.ngon_ngu == lang )
      if(!this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter) {
        this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter =  {
          gioi_thieu: null,
          anh_id: undefined,
          noi_dung: undefined,
        }
      } else if (
        this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter &&
        this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.anh_id
      ) {
        let dataImg = {
          id: this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.anh_id,
          name: this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.anh_id,
          url: ExtensionService.urlImg + this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.anh_id + "&r=square&w=512"
        };
        this.mData.fileUploadOption.AnhThongTin.fileList = [];
        this.mData.fileUploadOption.AnhThongTin.fileList.push(dataImg);
      }
      this.mData.dataForm.diem_den_an_toan.noiDungHienThiFilter.ngon_ngu = lang
      this.fn_album(lang)
    },
    fn_album(lang){
      this.mData.albumAnhFilter = this.mData.dataForm.diem_den_an_toan.album.filter(e => e.ngon_ngu == lang && e.anh_id);
      this.fn_disableUploadFile(this.mData.albumAnhFilter);
      if (this.mData.albumAnhFilter && this.mData.albumAnhFilter.length > 0) {
        let listImage = [];
        for (const element of this.mData.albumAnhFilter) {
          element.url = ExtensionService.urlImg + element.anh_id +"&r=clip&w=400&h=600&ha=center";
          let item = {};
          item = {
            name: element.anh_id,
            anh_id: element.anh_id,
            tieu_de: element.tieu_de,
            ngon_ngu: lang,
            type: element.type
          };
          item.url =
            ExtensionService.urlImg +
            element.anh_id + (this.typeImage.includes(item.type) ? "&r=clip&w=400&h=600&ha=center" : "");
          listImage.push(item);
        }
        this.mData.dataForm.diem_den_an_toan.listImageUrl = listImage;
        console.log('this.mData.dataForm.diem_den_an_toan.listImageUrl', this.mData.dataForm.diem_den_an_toan.listImageUrl);
        this.fn_filterImageUrl(this.mData.albumAnhFilter);
      } else {
        this.mData.dataForm.diem_den_an_toan.listImageUrl = [{
          name: undefined,
          anh_id: undefined,
          tieu_de: undefined,
          ngon_ngu: lang,
          type: undefined
        }]
      }
    },
    fn_checkVideo(item) {
      return item && item.type && this.typeVideo.includes(item.type)
    },
    fn_changeType(extension) {
      if (extension) {
        return "video/" + extension.replace(".", "");
      }
      return "";
    },
    fn_playVideo(item) {
      console.log('item', item);
      this.mData.dataDefault.dialogVideo.src = item.url;
      this.mData.dataDefault.dialogVideo.type = this.fn_changeType(item.type);
      this.mData.dataDefault.dialogVideo.show = true;
    },
    fn_closeDialogVideo() {
      this.mData.dataDefault.dialogVideo.src = "";
      this.mData.dataDefault.dialogVideo.type = "";
      this.mData.dataDefault.dialogVideo.show = false;
    },
    // End album ảnh
  },
  created: async function () {
    if (this.mData.dataForm.don_vi_cung_cap.duyet.duoc_duyet) {
      this.mData.ifHavePermission = false;
    }
    await this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-accept"
    ) {
      this.mData.viewMode = "accept";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  computed: {
    options() {
      return {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      };
    }
  },
};
</script>

<style scoped>
::v-deep .el-link {
  display: flex !important;
  justify-content: flex-start !important;
}

::v-deep .el-link--inner {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form-css {
  display: flex;
  flex-direction: column;
}

.checkbox-inactive {
  line-height: 24px;
}

.checkbox-active>span.el-radio__label {
  text-transform: uppercase;
  /* // color: rgb(63, 219, 16); */
}

.checkbox-active .is-checked+span.el-radio__label {
  text-transform: uppercase;
  /* // color: rgb(63, 219, 16); */
  font-weight: bold;
}

.checkbox-inactive>span.el-radio__label {
  text-transform: uppercase;
  /* // color: red; */
}

.checkbox-inactive .is-checked+span.el-radio__label {
  text-transform: uppercase;
  /* // color: red; */
  font-weight: bold;
}
</style>
